import { Navigate, Route, Routes, useLocation } from 'react-router-dom'
import { AppLayout } from './components/app-layout'
import { ActivityFeedProvider } from './lib/activity-feed'
import { RequireAuth } from './components/require-auth'
import { DashboardPage } from './pages/dashboard'
import { LoginPage } from './pages/login'
import { SettingsPage } from './pages/settings'
import { StrategiesPage } from './pages/strategies'
import { PnlPage } from './pages/pnl'

function WalletRedirect() {
  const location = useLocation()
  return <Navigate to={{ pathname: '/dashboard', search: location.search }} replace />
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        element={
          <RequireAuth>
            <ActivityFeedProvider>
              <AppLayout />
            </ActivityFeedProvider>
          </RequireAuth>
        }
      >
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/strategies" element={<StrategiesPage />} />
        <Route path="/pnl" element={<PnlPage />} />
        {/* the wallet is the dashboard now; old links keep their ?action= */}
        <Route path="/wallet" element={<WalletRedirect />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Route>
    </Routes>
  )
}
